<template>
  <Banner
    v-if="dealerId"
    :popup="false"
    :dealerName="dealerName"
    align="center"
    :size="size"
    :dealer-id="dealerId"
    :chain-sales-id="chainSalesId"
    :chain-after-sales-id="chainAfterSalesId"
    :language="language"
    :isIframe="true"
  ></Banner>
</template>

<script>
import Banner from './Banner.vue'
import store, { Module } from './store'

export default {
  store,
  name: 'Iframe',
  components: {
    Banner
  },
  mounted() {
    let uri = window.location.href.split('?')

    if (uri.length == 2) {
      let vars = uri[1].split('&')
      let tmp = ''
      vars.forEach(v => {
        tmp = v.split('=')
        if (tmp.length == 2 && tmp[0] in this && tmp[1] != '')
          this[tmp[0]] = parseValue(tmp[1], typeof this[tmp[0]])
      })
    }

    this.$root.uuid = `${this.dealerId}_${this.language}`.toLowerCase()
    if (!this.$store.hasModule(this.$root.uuid))
      this.$store.registerModule(this.$root.uuid, Module())

    this.$store.dispatch(
      `${this.$root.uuid}/setDealerName`,
      {
        name: this.dealerName
      },
      { root: true }
    )
    this.$store.dispatch(
      `${this.$root.uuid}/getDealer`,
      {
        querys: {
          language: this.language,
          popup: this.popup,
          dealerId: this.dealerId,
          chainSalesId: this.chainSalesId,
          category: this.category,
          chainAfterSalesId: this.chainAfterSalesId
        },
        wizardMode: this.wizardMode
      },
      { root: true }
    )
  },
  props: {
    wizardMode: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium'
    },
    dealerId: {
      type: String,
      default: ''
    },
    chainSalesId: {
      type: String,
      default: ''
    },
    chainAfterSalesId: {
      type: String,
      default: ''
    },
    dealerName: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'enXX'
    }
  }
}

function parseValue(value, type) {
  switch (type) {
    case 'boolean':
      return stringToBoolean(value)
    case 'string':
      return value
    case 'number':
      return parseInt(value, 10)
  }
}

function stringToBoolean(string) {
  switch (string.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true
    case 'false':
    case 'no':
    case '0':
    case null:
      return false
    default:
      return Boolean(string)
  }
}
</script>
